
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Action } from "vuex-class"

@Component({
	components: {
	}
})
export default class HeaderList extends Vue {
	@Prop()
	private value!: any | null;

	private headers: any[] = [];

	private formatValue () {
		if (this.value) {
			this.headers = JSON.parse(this.value)
		} else {
			this.headers = []
		}
	}

	@Watch("value", { deep: true })
	private valueWatcher () {
		this.formatValue()
	}

	private mounted () {
		this.formatValue()
	}

	private valueChanged (value:any) {
		try {
			this.$emit("input", JSON.stringify(this.headers))
		} catch {
		}
	}

	private addHeader () {
		if (this.headers && (this.headers.length === 0 || this.headers[this.headers.length - 1].header)) {
			this.headers.push({ header: null, value: null })
		}
	}

	private removeHeader (header: any) {
		if (this.headers) {
			this.headers.remove(header)
			this.valueChanged(null)
		}
	}
}
